import Default from "./Default";

export default Default;